<template>
    <BaseModal
        center
        :is-open="modalStore.modals.successModal"
        @close="closeModal">
        <button
            aria-label="Закрыть окно"
            style="
                cursor:
                    url(/assets/images/ui/icons/jpg-png/close-cursor.png),
                    pointer;
            "
            @click="closeModal"
            class="absolute inset-0 size-full outline-none" />

        <div
            class="bg-noise relative w-full max-w-[56.5rem] overflow-hidden rounded-20 bg-gradient-to-tr from-accent to-white/20 px-10 py-32 text-center md:py-36">
            <button
                type="button"
                aria-label="Закрыть окно"
                class="absolute right-5 top-5 text-white/70 transition hover:text-white md:right-7 md:top-7"
                @click="closeModal">
                <AtomIcon
                    name="close"
                    class="size-8 md:size-10" />
            </button>

            <div class="mx-auto max-w-[35rem]">
                <h2 class="text-32/100 font-semibold md:text-48/100">
                    Ваша заявка в&nbsp;работе!
                </h2>
                <p class="mx-auto mt-8 max-w-[28rem] text-16/148 md:mt-15">
                    Наши менеджеры свяжутся с&nbsp;вами в&nbsp;течение рабочего
                    дня.
                </p>
            </div>
        </div>
    </BaseModal>
</template>

<script setup lang="ts">
import AtomIcon from '~/components/atom/atom-icon/AtomIcon.vue'
import BaseModal from '~/components/base/base-modal/BaseModal.vue'

const modalStore = useModalStore()

async function closeModal() {
    modalStore.close('successModal')

    await navigateTo('/cart/')
}
</script>
